// Fires a GA4 conversion event when a user clicks an "Apply Now" CTA
// on one of the SEO hub pages, then lets navigation continue.
export function trackApplyClick(source: string) {
  try {
    const w = window as unknown as { gtag?: (...args: unknown[]) => void };
    w.gtag?.("event", "apply_cta_click", {
      event_category: "conversion",
      event_label: source,
      cta_source: source,
      cta_destination: "/#contact",
    });
    w.gtag?.("event", "generate_lead", {
      event_category: "conversion",
      event_label: source,
      value: 1,
    });
  } catch {
    // no-op
  }
}
